import { Session } from "../models/sessionModel";
import { EDIT_SESSION, SessionActionTypes, SET_SESSION } from "../types/actions";
import { Modes } from "../utils/constants";

const sessionReducerDefaultState: Session = {selectedProjectId:'', selectedFormId: '', selectedRowId: '', selectedElementId:'', selectedType:'', selectedMode:Modes.WORKING, viewRemark: false}

const sessionReducer = (state : Session = sessionReducerDefaultState, action : SessionActionTypes) : Session => {
    switch (action.type) {
        case SET_SESSION:
            return action.session;
        case EDIT_SESSION:
            return {...state,...action.session}
        default:
            return state;
    }
}

export default sessionReducer
